<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Store User</h1>
    <storeUserTable/>
  </v-card>
</template>

<script>
import storeUserTable from "@/components/back-office/InStore/StoreUser/UserListTable.vue";

export default {
  components: {
    storeUserTable
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href:  "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
           "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage"
      },
      {
        text: "Store user",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
